<template>
    <on-click-outside :do="close">
        <div ref="filter" class="relative w-64  z-20">
            <div @click.stop.prevent="switchPopper"
                    class="h-8 elems  border border-grey-dark text-center items-center outline-none text-grey-darkest w-full
                            flex item-center justify-between text-sm px-2 py-4 pl-4 cursor-pointer">
                {{filterOptions[selectedOption].name}}
                <img src = "@/assets/dropdown-arrow.png"
                                            class = "h-1 mr-2"/>
            </div>
            <div ref="elements" v-show="showFilter" class="absolute border elems border-brand-grey-light overflow-hidden bg-white shadow-md w-full">
                <p v-for="(option, id, key) in filterOptions" :key="key"
                  class="lg:hover:bg-brand-light hover:text-white p-2 cursor-pointer text-grey-darkest h-16 h-auto"
                  @click.prevent="changeOption(id)">{{option.name}}</p>
            </div>
        </div>
    </on-click-outside>
</template>

<script>
import Popper from 'popper.js';
import OnClickOutside from '../../OnClickOutside';
import debounce from 'lodash/debounce';
import clone from 'lodash/cloneDeep';

export default {
  name: 'filter-games',
  components: { OnClickOutside },
  props: ['haveUser'],
  data() {
    return {
      showFilter: null,
      hideSelectboxHandler: null,
      filterOptions: {
        0: { name: 'Все игры', value: 'all' },
        1: { name: 'Регистрация открыта', value: 'opened' },
        2: { name: 'Резерв', value: 'reserved' },
      },
      selectedOption: 0,
    };
  },
  created() {
    if (this.haveUser.length) {
      this.filterOptions = {
        ...this.filterOptions,
        3: { name: 'Мои регистрации', value: 'user' },
      };
    }
    if (this.$route.query.type) {
      Object.keys(this.filterOptions).forEach((item) => {
        if (this.$route.query.type === this.filterOptions[item].value) {
          this.selectedOption = item;
        }
      });
    }
    this.hideSelectboxHandler = () => {
      this.showFilter = false;
    };

    this.newSort(this.filterOptions[this.selectedOption].value);
  },
  watch: {
    showBox() {
      if (this.showFilter) {
        this.setupPopper();
        document.addEventListener('click', this.hideSelectboxHandler);
      } else {
        document.removeEventListener('click', this.hideSelectboxHandler);
      }
    },
    selectedOption(val) {
      this.newSort(this.filterOptions[val].value);
    },
    haveUser(n, o) {
      if (!n.length && o.length) {
        this.filterOptions = {
          0: { name: 'Все игры', value: 'all' },
          1: { name: 'Регистрация открыта', value: 'opened' },
          2: { name: 'Резерв', value: 'reserved' },
        };
        this.newSort(this.filterOptions[0].value);
      } else {
        this.filterOptions = {
          0: { name: 'Все игры', value: 'all' },
          1: { name: 'Регистрация открыта', value: 'opened' },
          2: { name: 'Резерв', value: 'reserved' },
          3: { name: 'Мои регистрации', value: 'user' },
        };
      }
    },
  },
  beforeDestroy() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    close() {
      if (!this.showFilter) {
        return;
      }
      this.showFilter = false;
    },
    switchPopper() {
      this.showFilter = !this.showFilter;
      if (this.showFilter) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    changeOption(id) {
      this.selectedOption = id;
      this.showFilter = false;
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.filter, this.$refs.elements, {
          placement: 'bottom',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    newSort: debounce(function (sort) {
      const query = clone(this.$route.query);
      query.type = `${sort}`;
      const searchQuery = {};
      for (const key in query) {
        if (query[key] === '') {
          continue;
        }
        searchQuery[key] = query[key];
      }
      this.$router.push({ query: searchQuery });
    }, 800),
  },
};
</script>

<style scoped>
.elems {
  border-radius: 5px;
}
</style>
